import { useState, useEffect } from "react";
import "./index.scss";

interface IProps {
  selectOptions: any[];
  value?: string;
  onSelect?: (d: any) => void;
  style?: React.CSSProperties;
  className?: string;
}

const SelectBar = (props: IProps) => {
  const { selectOptions, onSelect, style, className } = props;
  const [value, setValue] = useState<string>();
  const [showDropDown, setShowDropDown] = useState(false);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  return (
    <div className={`select ${className}`} style={style}>
      <div className="valueWrap" onClick={() => setShowDropDown(true)}>
        <div className="value">{value || "请选择居委"}</div>
        {/* <img src="" alt="" /> */}
      </div>
      {showDropDown && (
        <div className="dropDown">
          {selectOptions.map((item, index) => (
            <div
              className="dropDownItem"
              key={index}
              onClick={() => {
                onSelect?.(item);
                setValue(item.name);
                setShowDropDown(false);
              }}
            >
              {item.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectBar;
